import * as React from "react";

import styled from "styled-components";

interface ToolTipProps {
  className?: string;
  children: React.ReactNode;
  helperText: string;
}

export const ToolTip: React.FC<ToolTipProps> = (props) => {
  const [showTooltip, setShowTooltip] = React.useState(false);
  return (
    <ToolTipWrapper
      className={props.className}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <Flex>
        {showTooltip && <HelperText>{props.helperText}</HelperText>}
        {props.children}
      </Flex>
    </ToolTipWrapper>
  );
};

export default styled(ToolTip)``;

const Flex = styled.div`
  display: flex;
  align-items: center;
`;

const HelperText = styled.div`
  color: white;
  background-color: black;
  font-family: Sans-Serif;
  display: inline-block;
  border-radius: 4px;
  padding: 10px;
`;

const ToolTipWrapper = styled.div``;
